import React from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup, Label, Input,
} from 'reactstrap';
import {
  capitalizeEveryWord, regexPattern, staticConstants, GRAPH_CONST_VALUES,
} from '../../../utils';

function NumberOfFollowers(props) {
  const {
    errors, register, formData,
  } = props;

  const renderInputFiled = (label, inputName) => (
    <FormGroup className={`input-field demographic-input
      ${errors[inputName] && `${staticConstants.ERROR_CLASS.FORM_ERROR}`}`}
    >
      <Label
        for={label}
      >
        {capitalizeEveryWord(label)}
      </Label>
      <Input
        type="text"
        name={inputName}
        value={formData[inputName]}
        innerRef={register({
          pattern: {
            value: regexPattern.NUMBER_ONLY,
          },
        })}
      />
    </FormGroup>
  );

  return (
    <>
      {renderInputFiled(staticConstants.SOCIAL_SHARE_TYPE.FACEBOOK, GRAPH_CONST_VALUES.FOLLOWERS.FACEBOOK)}
      {renderInputFiled(staticConstants.SOCIAL_SHARE_TYPE.INSTAGRAM, GRAPH_CONST_VALUES.FOLLOWERS.INSTAGRAM)}
      {renderInputFiled(staticConstants.SOCIAL_SHARE_TYPE.YOUTUBE, GRAPH_CONST_VALUES.FOLLOWERS.YOUTUBE)}
      {renderInputFiled(staticConstants.SOCIAL_SHARE_TYPE.TWITTER, GRAPH_CONST_VALUES.FOLLOWERS.TWITTER)}
      {renderInputFiled(staticConstants.SOCIAL_SHARE_TYPE.SPOTIFY, GRAPH_CONST_VALUES.FOLLOWERS.SPOTIFY)}
    </>
  );
}

NumberOfFollowers.propTypes = {
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
};

export default NumberOfFollowers;
